<template>
  <div class="mq-tabs columns small-22 small-offset-1">
    <div class="row collapse">
      <div
        v-for="(item, index) in items"
        :key="index"
        :class="`column ${tabClass}`"
        @click="selectedTab(index)"
      >
        <div :class="`tab-wrapper ${isSelectedClass(index)}`">
          <slot name="tab" :item="item" :index="index"></slot>
        </div>

      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'mq-tabs',

  props: {
    items: {
      type: Array
    },
    selectedIndex: {
      type: Number
    }
  },

  methods: {
    selectedTab(index) {
      this.$emit('select', index)
    },

    isSelectedClass(index) {
      if (index == this.selectedIndex) {
        return 'active';
      }
      return 'inactive';
    }
  },

  computed: {
    tabClass() {
      return `medium-${24 / this.items.length} small-${24 / this.items.length}`
    }
  }

}
</script>

<style lang="scss" scoped>
.active {
  background-color: white;
  @include breakpoint(medium up) {
    @include button-effects(4px, #D6D6D6);
    .dark-slide & {
      color: black;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MqTabs.vue